import React, { useMemo, useState, useEffect } from 'react'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { useWeb3React } from '@web3-react/core'
import { LinkExternal, Text, Flex } from '@pancakeswap-libs/uikit'
import { FarmWithStakedValue } from 'views/Farms/components/FarmCard/FarmCard'
import getLiquidityUrlPathParts from 'utils/getLiquidityUrlPathParts'
import { communityFarms } from 'config/constants'
import { CommunityTag, CoreTag, DualTag, NoFeeTag } from 'components/Tags'
import { usePriceCakeBusd, usePriceContract, usePriceBnbbyPid } from 'state/hooks'
import BigNumber from 'bignumber.js'
import { getMasterChefAddress } from 'utils/addressHelpers'
import HarvestAction from './HarvestAction'
import StakedAction from './StakedAction'
import Apr, { AprProps } from '../Apr'
import Multiplier, { MultiplierProps } from '../Multiplier'
import Liquidity, { LiquidityProps } from '../Liquidity'


export interface ActionPanelProps {
  apr: AprProps
  multiplier: MultiplierProps
  liquidity: LiquidityProps
  details: FarmWithStakedValue
  depositFee?: number
}

const Container = styled.div`
  background: ${({ theme }) => theme.colors.background};
  display: flex;
  width: 100%;
  flex-direction: column-reverse;
  padding: 24px;

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: row;
    padding: 16px 32px;
  }
`

const StyledLinkExternal = styled(LinkExternal)`
  font-weight: 400;
`

const StakeContainer = styled.div`
  color: ${({ theme }) => theme.colors.text};
  align-items: center;
  display: flex;
  justify-content: space-between;

  ${({ theme }) => theme.mediaQueries.sm} {
    justify-content: flex-start;
  }
`

const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 25px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-top: 16px;
  }

  > div {
    height: 24px;
    padding: 0 6px;
    font-size: 14px;
    margin-right: 4px;

    svg {
      width: 14px;
    }
  }
`

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
  }
`

const InfoContainer = styled.div`
  min-width: 200px;
`

const ValueContainer = styled.div`
  display: block;

  ${({ theme }) => theme.mediaQueries.lg} {
    display: none;
  }
`

const ValueWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0px;
`

const ActionPanel: React.FunctionComponent<ActionPanelProps> = ({ details, apr, multiplier, liquidity, depositFee }) => {
  const farm = details

  const TranslateString = useI18n()
  const { quoteToken, token, dual } = farm
  const lpLabel = farm.lpSymbol && farm.lpSymbol.toUpperCase().replace('PANCAKE', '')
  const liquidityUrlPathParts = getLiquidityUrlPathParts({
    quoteTokenAddress: quoteToken.address,
    tokenAddress: token.address,
  })
  const lpAddress = farm.lpAddresses[process.env.REACT_APP_CHAIN_ID]
  const bsc = `https://bscscan.com/address/${lpAddress}`
  const info = `https://pancakeswap.info/pair/${lpAddress}`
  const isCommunityFarm = communityFarms.includes(token.symbol)

  // console.log(farm.depositFeeBP);
  // console.log(farm.depositFeeBP)



  // ZCORE
  let stakedBalance;
  const cakePrice = usePriceCakeBusd()
  const { account } = useWeb3React()

  if(farm.userData){
    stakedBalance = farm.userData.stakedBalance;
  }else{
    stakedBalance = new BigNumber(0);
  }

  let tokenPriceVsQuote;
  if(farm.tokenPriceVsQuote){
    tokenPriceVsQuote = farm.tokenPriceVsQuote;
  }else{
    tokenPriceVsQuote = new BigNumber(0);
  }

  let earnings;
  if(farm.userData){
    earnings = farm.userData.earnings;
  }else{
    earnings = new BigNumber(0);
  }  

  const divFarm = 2
  const myEarning: BigNumber = useMemo(() => {
    return new BigNumber(cakePrice.toNumber() * earnings)
  }, [earnings, cakePrice])  


  const myEarningFormated = myEarning
    ? `$${Number(myEarning.toNumber()/1000000000000000000).toLocaleString(undefined, { maximumFractionDigits: 0 })}`
    : '-'  

  let mystaked = 0
  let tokenA = 0
  let tokenB = 0


const dataTokenAddress = farm.token.address[process.env.REACT_APP_CHAIN_ID]
const dataQuoteTokenAddress = farm.quoteToken.address[process.env.REACT_APP_CHAIN_ID]
const dataLPAddress = farm.lpAddresses[process.env.REACT_APP_CHAIN_ID]

const zefiStatus = usePriceContract(dataTokenAddress, dataQuoteTokenAddress, dataLPAddress)
// const zefiStatus = usePriceBnbbyPid(farm.pid)

// console.log ( JSON.stringify(zefiStatus) )

/*
const [zefiStatus, setzefiStatus] = useState(usePriceContract(dataTokenAddress, dataQuoteTokenAddress, dataLPAddress))
  useEffect(() => {

      // const tempzefiStatus = usePriceContract(dataTokenAddress, dataQuoteTokenAddress, dataLPAddress)
      console.log ( JSON.stringify(zefiStatus) )

       setzefiStatus(zefiStatus)
  }, [zefiStatus, dataTokenAddress, dataQuoteTokenAddress, dataLPAddress])
*/

/*
const masterChefContract = getMasterChefAddress()
const [historyData, setHistoryData] = useState(null)
  useEffect(() => {

    // const url = `https://api.bscscan.com/api?apikey=XPN8PKZMHGXX29CDM6TUJNM5HY4S4H7PVM&module=stats&action=tokensupply&contractaddress=${farm.lpAddresses[process.env.REACT_APP_CHAIN_ID]}`

    // const url = `https://api.bscscan.com/api?apikey=XPN8PKZMHGXX29CDM6TUJNM5HY4S4H7PVM&module=account&action=tokenbalance&contractaddress=${farm.lpAddresses[process.env.REACT_APP_CHAIN_ID]}&address=${masterChefContract}`

    const url = `https://finance.zcore.network/lp-det?lp=${farm.lpAddresses[process.env.REACT_APP_CHAIN_ID]}&tokenA=${farm.token.address[process.env.REACT_APP_CHAIN_ID]}&tokenB=${farm.quoteToken.address[process.env.REACT_APP_CHAIN_ID]}`

    // console.log( url )

    if(stakedBalance > 0 && historyData === null){
    fetch(url)
      .then((response) => response.json())
      .then((data) => setHistoryData( JSON.stringify(data)))
      .catch(() => {
        setHistoryData(null)
      })
      // console.log('CALL!')
    }else{
       setHistoryData(historyData)
    }
  }, [stakedBalance, farm, account, masterChefContract, historyData])
*/




  if(stakedBalance > 0 && zefiStatus !== null){    

    // const JSONlp = JSON.parse(historyData)
    // const totLP = JSONlp.tot_lp
    // const totMC = JSONlp.masterchef
    
    const totLP = zefiStatus.lpTotalSupply
    const totMC = zefiStatus.lpTokenBalanceMC
    
    tokenA = stakedBalance/1000000000000000000 * (zefiStatus.tokenBalanceLP / zefiStatus.lpTotalSupply)
    tokenB = stakedBalance/1000000000000000000 * (zefiStatus.quoteTokenBlanceLP / zefiStatus.lpTotalSupply)
    
    const ntotalValue = new BigNumber(farm.liquidity)
    // mystaked = (ntotalValue.toNumber() * (stakedBalance/1000000000000000000) / (totMC))
    mystaked = (zefiStatus.thisPrice * (stakedBalance/1000000000000000000))
    // mystaked = 0

/*
    console.log('==============================')
    console.log( farm.liquidity.toNumber() )
    console.log( tokenA )
    console.log( tokenB )
    // console.log( JSONlp.unit_tokenA )
    // console.log( JSONlp.unit_tokenB )    
    // console.log( JSON.stringify(farm.userData) )
    console.log(farm.lpSymbol)
    console.log(farm.lpAddresses[process.env.REACT_APP_CHAIN_ID])
    console.log(farm.tokenPriceVsQuote)
    console.log(ntotalValue.toNumber())
    // console.log(historyData/1000000000000000000)
    console.log(stakedBalance/1000000000000000000)
    console.log(mystaked)
    console.log( JSON.stringify(farm) )
    console.log(farm.token.address[56])
    console.log(farm.quoteToken.address[56])
    console.log('==============================')
*/    

  }




  const myLPFormated = mystaked
    ? `$${mystaked.toFixed(2)}`
    : '-'   









  return (
    <Container>
      <InfoContainer>
        <StakeContainer>
          <StyledLinkExternal href={`https://exchange.zcore.network/#/swap?inputCurrency=BNB&outputCurrency=${farm.token.address[process.env.REACT_APP_CHAIN_ID]}`}>
            {TranslateString(999, `Get ${lpLabel}`, { name: lpLabel })}
          </StyledLinkExternal>
        </StakeContainer>
        {/* <StyledLinkExternal href={bsc}>{TranslateString(999, 'View Contract')}</StyledLinkExternal> */}
        {/* <StyledLinkExternal href={info}>{TranslateString(999, 'See Pair Info')}</StyledLinkExternal> */}
        <Flex justifyContent="space-between">
        <Text style={{ marginTop: '10px' }}>My Staked Value: {myLPFormated}</Text>
        </Flex>
        {/*
          <Flex justifyContent="space-between">
          <Text style={{ fontSize: '14px' , marginTop: '0px' }}>({tokenA.toFixed(4)} {farm.token.symbol} + {tokenB.toFixed(4)} {farm.quoteToken.symbol})</Text>
          </Flex>
        
      <Flex justifyContent="space-between">
        <Text bold style={{ color: '#FF0000', fontSize: '20px' , marginTop: '10px' }}>
          {farm.depositFeeBP === 0 ? <NoFeeTag /> : `Deposit Fee: ${farm.depositFeeBP / 100}%`}
        </Text>
      </Flex>              
      */}
        <TagsContainer>          
          {/* {isCommunityFarm ? <CommunityTag /> : <CoreTag />} */}
          {dual ? <DualTag /> : null}
        </TagsContainer>
      </InfoContainer>
      <ValueContainer>
        <ValueWrapper>
          <Text>{TranslateString(736, 'APR')}</Text>
          <Apr {...apr} />
        </ValueWrapper>
        <ValueWrapper>
          <Text>Deposit Fee</Text>
          <Multiplier {...multiplier} />
        </ValueWrapper>
        <ValueWrapper>
          <Text>{TranslateString(999, 'Liquidity')}</Text>
          <Liquidity {...liquidity} />
        </ValueWrapper>
      </ValueContainer>
      <ActionContainer>
        <HarvestAction {...farm} />
        <StakedAction {...farm} />
      </ActionContainer>
    </Container>
  )
}

export default ActionPanel
